import { render, staticRenderFns } from "./HubIcon.vue?vue&type=template&id=6c2340f8&scoped=true"
import script from "./HubIcon.vue?vue&type=script&lang=js"
export * from "./HubIcon.vue?vue&type=script&lang=js"
import style0 from "./HubIcon.vue?vue&type=style&index=0&id=6c2340f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2340f8",
  null
  
)

export default component.exports